import moment from "moment";
import React, { useState, useEffect, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { Modal } from "react-bootstrap";
import { toast } from "react-toastify";
import { removeCompany, changeCompanyStatus as changeCompanyStatusApi, resendVerificationEmail } from "../../api/company";
import DeleteModal from "../../component/Modal/Delete";
import Paginations from "../../component/Pagination";
import { FetchCompanyList } from "./CompanySlice";
import { BiBorderRadius } from "react-icons/bi";
function Companies() {
  const dispatch = useDispatch();
  const list = useSelector((state) => state.company.list);
  const total = useSelector((state) => state.company.total);
  const [search, setSearch] = useState("");
  const [show, setShow] = useState(false);
  const [delId, setDelId] = useState("");
  const [page, setPage] = useState(1);

  const [companyId, setCompanyId] = useState("");
  const [companyStatus, setCompanyStatus] = useState("");
  const [companyEmail, setCompanyEmail] = useState("");
  const [companySlug, setCompanySlug] = useState("");
  const [companyPassword, setCompanyPassword] = useState("");
  const [deactivationReason, setDeactivationReason] = useState("");
  const [displayDeactivateModal, setDisplayDeactivateModal] = useState(false);
  const [displayActivateModal, setDisplayActivateModal] = useState(false);
  const [resendingId, setResendingId] = useState(null);

  const handleResendVerification = (companyId) => {
    setResendingId(companyId);
    resendVerificationEmail({ companyId }).then((res) => {
      setResendingId(null);
      if (res?.code === 1) {
        toast.success("Verification email sent successfully!");
      } else {
        toast.error(res?.message || "Failed to resend verification email", { autoClose: false, closeButton: true });
      }
    }).catch(() => {
      setResendingId(null);
      toast.error("An error occurred while resending the email.");
    });
  };

  const handleShow = () => {
    setShow(!show);
  };

  const confirmDelete = () => {
    removeCompany({ company_id: delId }).then((res) => {
      if (res?.code === 1) {
        setDelId("");
        getList();
        toast.success(res?.message);
      } else {
        toast.error(res?.message, {  autoClose: false,  closeButton: true});
      }
    });
  };

  const changeCompanyStatus = (id, status, email, slug) => {
    setCompanyStatus(status);
    setCompanyId(id)
    setCompanyEmail(email)
    setCompanySlug(slug)
    let password = slug+id+'!@#';
    setCompanyPassword(password)
    if(status == 1){
      setDisplayActivateModal(true)
    }else{
      setDisplayDeactivateModal(true)
    }
  };
  const changeCompanyStatusCallApi=()=>{
    if (companyStatus === 0 && !deactivationReason) {
      toast.error("Please provide a reason for deactivation", {  autoClose: false,  closeButton: true});
      return;
    }
    changeCompanyStatusApi({ 
      company_id: companyId, 
      status: companyStatus, 
      slug: companySlug, 
      password: companyPassword,
      reason: deactivationReason 
    }).then((res) => {
      if (res?.code === 1) {
        setDisplayDeactivateModal(false)
        setDisplayActivateModal(false)
        setDeactivationReason("")
        getList();
        toast.success(res?.message);
      } else {
        toast.error(res?.message, {  autoClose: false,  closeButton: true});
      }
    });
  };

  const getList = useCallback(() => {
    dispatch(FetchCompanyList({ page, search, limit: 10 }));
  }, [dispatch, search, page]);

  useEffect(() => {
    getList();
  }, [getList]);

  return (
    <article className="col-lg-9 articleClass">
      <div className="article-body store-bd-gy">
        <div className="row align-items-center col-rever">
          <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div className="link-active shadow">
              <p>
                <img src="assets/images/event-calender-selected.png" alt="" />{" "}
                Companies {total}
              </p>
            </div>
          </div>
          <div className="col-sm-12 col-md-6 col-lg-6 mb-3">
            <div className="d-flex align-items-center lg-justify-content-end">
              <form className="has-search">
                <span className="form-search-icon form-control-feedback"></span>
                <input
                  type="text"
                  className="form-control shadow"
                  placeholder="Search Company By Name"
                  value={search}
                  onChange={(e) => {
                    setPage(1);

                    setSearch(e.target.value);
                  }}
                />
              </form>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-sm-12">
            <div className="table-responsive text-center">
              <table className="table storetable">
                <thead className="text-center">
                  <tr>
                    <th scope="col">ID</th>
                    <th scope="col">Company Name</th>
                    <th scope="col">Owner Name</th>
                    <th scope="col">Email</th>
                    <th scope="col">Location</th>
                    <th scope="col">Status</th>
                    <th scope="col">Action</th>
                  </tr>
                  <tr className="border-0 bg-none invisible">
                    <td className="border-0 bg-none"></td>
                  </tr>
                </thead>
                <tbody>
                  {list?.length > 0 ? (
                    list?.map((item, i) => {
                      return (
                        <tr key={i}>
                          <td>{item?.id || "NA"}</td>
                          <td>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                              {item?.logo ? (
                                <img 
                                  src={item?.logo} 
                                  alt="" 
                                  style={{ 
                                    height: '50px', 
                                    width: '50px', 
                                    borderRadius: '50%',
                                    objectFit: 'cover'
                                  }} 
                                />
                              ) : (
                                <div
                                  style={{
                                    height: '50px',
                                    width: '50px',
                                    borderRadius: '50%',
                                    backgroundColor: '#e9ecef',
                                    color: '#6c757d',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    fontSize: '18px',
                                    fontWeight: 'bold'
                                  }}
                                >
                                  {(item?.company_name || '?').charAt(0).toUpperCase()}
                                </div>
                              )}
                              <span>{item?.company_name || "NA"}</span>
                            </div>
                          </td>
                          <td>{item?.full_name || "NA"}</td>
                          <td>{item?.email || "NA"}</td>
                          <td>{item?.country || "NA"} - {item?.city || "NA"}</td>
                          <td className="text-center">
                            {item.email_verified == false && (
                              <div className="d-flex flex-column align-items-center mb-2">
                                <span
                                  style={{
                                    color: '#dc3545',
                                    fontWeight: '500',
                                    padding: '2px 5px',
                                    fontSize: '12px',
                                    marginBottom: '3px'
                                  }}
                                >
                                  Email not verified
                                </span>
                                <button
                                  className="btn btn-sm btn-outline-primary"
                                  onClick={() => handleResendVerification(item.id)}
                                  disabled={resendingId === item.id}
                                  style={{ fontSize: '11px', padding: '1px 5px' }}
                                >
                                  {resendingId === item.id ? 'Sending...' : 'Resend Email'}
                                </button>
                              </div>
                            )}

                            <button
                              className="btn"
                              onClick={() => changeCompanyStatus(item.id, item.status === 1 ? 0 : 1, item.email, item.slug)}
                              title={
                                item.status === 0 && item.is_profile_complete == 0
                                  ? "Inactive Company"
                                  : item.status === 1 && item.is_profile_complete == 0
                                  ? "Company On Boarding"
                                  : "Click here to Deactivate"
                              }
                              style={{
                                color:
                                  item.status === 0 && item.is_profile_complete == 0
                                    ? '#c20824' // red
                                    : item.status === 1 && item.is_profile_complete == 0
                                    ? '#ffc107' // yellow
                                    : '#28a745', // green

                                fontWeight: '500',
                                padding: '5px 10px',
                                borderRadius: '4px',
                                width: '100%',

                                backgroundColor:
                                  item.status === 0 && item.is_profile_complete == 0
                                    ? 'rgba(194, 8, 36, 0.1)'
                                    : item.status === 1 && item.is_profile_complete == 0
                                    ? 'rgba(255, 193, 7, 0.15)'
                                    : 'rgba(40, 167, 69, 0.1)',

                                border: 'none'
                              }}
                            >
                              {item.status === 0 && item.is_profile_complete == 0
                                ? 'Inactive'
                                : item.status === 1 && item.is_profile_complete == 0
                                ? 'On Boarding'
                                : 'On Board'}
                            </button>
                          </td>
                          <td>
                            <div className="d-flex justify-content-center action">
                              <button className="btn">
                                <Link to={`/company/${item?.id}`}>
                                  <img src="assets/images/view.png" alt="" />
                                </Link>
                              </button>
                              <button className="btn">
                                <Link to={`/company/edit/${item?.id}`}>
                                  <img src="assets/images/edit.png" alt="" />
                                </Link>
                              </button>
                              <button className="btn" title="View Subscription">
                                <Link to={`/company/subscription/${item?.id}`}>
                                  <img src="assets/images/time-colored.png" alt="" />
                                </Link>
                              </button>
                              <button
                                className="btn"
                                onClick={() => {
                                  setDelId(item.id);
                                  handleShow();
                                }}
                                title="Delete"
                              >
                                <img src="assets/images/delete.png" alt="" />
                              </button>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={10}>No data found.</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>
            {total > 10 && total && (
              <Paginations handlePage={setPage} page={page} total={total} />
            )}
          </div>
        </div>
      </div>

      <DeleteModal
        page="Company"
        show={show}
        handleShow={() => {
          handleShow();
        }}
        cancel={() => {
          setShow(false);
        }}
        confirmDelete={confirmDelete}
      />



    <Modal show={displayDeactivateModal} size="md" centered>
      <div className="modal-content body-bg">
        <div className="modal-header border-0">
          <button
            type="button"
            className="btn-close"
            onClick={() => setDisplayDeactivateModal(false)}
          ></button>
        </div>
        <div className="modal-body text-center mb-4">
          <h4>Deactivate Company?</h4>
          <p>Are you sure you want to deactivate this company? After deactivation, this company will no longer be able to access the site.</p>
          
          <div className="form-group text-start mb-3">
            <textarea 
              className="form-control" 
              rows="5"
              style={{
                minHeight: '150px',
                resize: 'vertical',
                fontSize: '14px',
                padding: '12px',
                width: '100%'
              }}
              value={deactivationReason}
              onChange={(e) => setDeactivationReason(e.target.value)}
              placeholder="Please provide a reason for deactivation"
            ></textarea>
          </div>

          <div className="view-btns">
            <button
              className="btn btn-reject btn-view mt-2"
              onClick={() => {
                setDisplayDeactivateModal(false);
                setDeactivationReason("");
              }}
            >
              No
            </button>
            <button
              className="btn btn-accept btn-view mt-2"
              onClick={changeCompanyStatusCallApi}
            >
              Yes
            </button>
          </div>
        </div>
      </div>
    </Modal>


    <Modal show={displayActivateModal} size="lg" centered>
      <div className="modal-content body-bg">
        <div className="modal-header border-0">
          <button
            type="button"
            className="btn-close"
            onClick={() => setDisplayActivateModal(false)}
          ></button>
        </div>
        <div className="modal-body text-center mb-4">
          <h4>Activate Company?</h4>
          <p>Are you sure you want to activate this company and send the login credentials to them for site access?</p>
          <div className="credentials-info text-start mb-4">
            <p><strong>Admin Panel URL : </strong> https://admin.bookinclass.co.uk</p>
            <p><strong>Email : </strong> {companyEmail}</p>
            <p><strong>Password : </strong>{companyPassword}</p>
            <hr/>
            <p><strong>User Panel URL : </strong> https://{companySlug}.bookinclass.co.uk</p>
          </div>

          <div className="view-btns">
            <button
              className="btn btn-reject btn-view mt-2"
              onClick={() => setDisplayActivateModal(false)}
            >
              No
            </button>
            <button
              className="btn btn-accept btn-view mt-2"
               onClick={() => {
                changeCompanyStatusCallApi();
              }}
            >
              Yes, Activate & Send Mail
            </button>
          </div>
        </div>
      </div>
    </Modal>

    </article>
  );
}

export default Companies;
